import { t } from "i18next";
import { onlyRoleMapping } from "../../../engine/AuthRoute";
import { daysJsFormat, formatCurrency, roles } from "../../../utils/constants";
import dayjs from "../../../utils/dayjs";
import React from "react";

const findErrorText = obj => {
  if (typeof obj !== "object" || obj === null) return null;

  if (Object.prototype.hasOwnProperty.call(obj, "ErrorText")) return obj.ErrorText;
  if (Object.prototype.hasOwnProperty.call(obj, "Description")) return obj.Description;
  if (Object.prototype.hasOwnProperty.call(obj, "error")) return obj.error;

  for (const key in obj) {
    const result = findErrorText(obj[key]);
    if (result) return result;
  }

  return null;
};

const renderCffError = error => {
  if (error == null) return null;

  if (typeof error === "object") {
    const errorText = findErrorText(error);
    return errorText ? <div style={{ color: "red" }}>{errorText}</div> : null;
  }

  if (typeof error === "string") {
    try {
      const parsed = JSON.parse(error);
      if (parsed.error) return <div style={{ color: "red" }}>{parsed.error}</div>;
      const errorText = findErrorText(parsed);
      if (errorText) return <div style={{ color: "red" }}>{errorText}</div>;
    } catch {
      // plain-text error from server (e.g. XML parse failure)
    }
    return <div style={{ color: "orange" }}>{error}</div>;
  }

  return null;
};

export const formAmountBillet = ({ amountBillet, t, prestation }) => {
  return {
    type: "input-currency",
    name: "amountBillet",
    value: amountBillet,
    label: t("prestationInformations.amountTrain"),
    placeholder: t("prestationInformations.amountTrain"),
    disabled: !onlyRoleMapping([roles.admin]),
    quote:
      prestation?.cff !== undefined ? (
        <>
          {/*https://www.sbb.ch/fr?date=%222024-11-21%22&moment=%22ARRIVAL%22&stops=%5B%7B%22value%22%3A%22A%3D2%40O%3D1512%20Chavannes-sur-Moudon%2C%20Carmagnaule%201%40H%3D1%40X%3D6812214%40Y%3D46656451%40U%3D103%40L%3D990116119%40B%3D1%40p%3D1731927785%40%22%2C%22type%22%3A%22ID%22%2C%22label%22%3A%221512%20Chavannes-sur-Moudon%2C%20Carmagnaule%201%22%7D%2C%7B%22value%22%3A%228579174%22%2C%22type%22%3A%22ID%22%2C%22label%22%3A%22Vevey%2C%20gare%22%7D%5D&time=%2214%3A43%22*/}
          <p>
            {prestation?.cff?.fromCache
              ? t("prestationInformations.infocffCache")
              : t("prestationInformations.infocff")}{" "}
            {!prestation?.cff?.fromCache && prestation?.cff?.dateUsed !== null ? (
              <b>
                {" "}
                : {dayjs(prestation?.cff?.dateUsed).format(daysJsFormat.full)}
              </b>
            ) : null}
          </p>
          <hr />
          {prestation?.cff?.priceApi !== null ? (
            <>
              <b>{formatCurrency(prestation?.cff?.priceApi)}</b> * 2 ={" "}
              {formatCurrency(prestation?.cff?.priceFinal)} {}
            </>
          ) : null}

          {onlyRoleMapping([roles.admin, roles.permanance]) ? (
            <>
              {prestation?.cff?.error !== undefined ? (
                <>
                  <hr />
                  <b>
                    Admin info : check error on DB / Log
                    {renderCffError(prestation?.cff?.error)}
                  </b>
                </>
              ) : null}
            </>
          ) : null}
        </>
      ) : (
        undefined
      ),
    col: 24,
  };
};
